module.exports = __webpack_public_path__ + "static/media/debut-light.8fa3865e.png";